import PropTypes from "prop-types";
import { Login } from "vino/components";

const Block = ({ attributes }) => {
	return <Login attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
